import { createApp } from 'vue';
import App from './App';
import router from '@/router';
import store from '@/store';
import axios from 'axios';

axios.defaults.baseURL = '/';
// подпись Telegram Web App во всех запросах: по ней бэкенд узнаёт пользователя и права админа
const tgInit = () =>
  window.Telegram && window.Telegram.WebApp ? window.Telegram.WebApp.initData : '';
axios.interceptors.request.use((cfg) => {
  cfg.headers['X-Tg-Init-Data'] = tgInit();
  return cfg;
});
window.tgFetchHeaders = () => ({ 'X-Tg-Init-Data': tgInit() });

createApp(App).use(router).use(store).mount('#app');
